export default __webpack_public_path__ + "static/media/img3.ca732ac9.jpeg";